import agencyApi from 'api/agencyApi';
import agencyCommissionApi from 'api/agencyCommissionApi';
import axiosClient from 'api/axiosClient';
import AgencyHelper from 'features/Agency/agencyHelper';
import AgencyContractListView from 'features/Agency/components/AgencyContractListView';
import AgencySaleOrderListView from 'features/Agency/components/AgencySaleOrderListView';
import EnergyBillListView from 'features/Charge/ChargeEnergyBill/components/EnergyBillListView';
import ChargeHelper from 'features/Charge/chargeHelper';
import ChargeStationCompactListView from 'features/Charge/ChargeStation/components/ChargeStationCompactListView';
import BankAccountsView from 'features/ManageDealer/components/BankAccountsView';
import BuildInfoCardView from 'features/ManageDealer/components/BuildInfoCardView';
import RemainingAgenciesView from 'features/ManageDealer/components/RemainingAgenciesView';
import TransactionHistoryView from 'features/ManageDealer/components/TransactionHistoryView';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import PackageTransactionView from 'features/ManageInvestor/components/PackageTransactionView';
import { AnimatePresence, motion } from 'framer-motion';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import AppTabs from 'general/components/AppTabs';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTScrollCard from 'general/components/OtherKeenComponents/KTScrollCard';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomCard from 'general/components/Others/CustomCard';
import { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import agencyBankHelper from 'general/helpers/agencyBankHelper';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function CoinvestorDetailScreen(props) {
  // ---- params ----
  const { isCoinvestorInfo = false } = props;
  const { t } = useTranslation();
  const router = useRouter();
  const agencyId = router.query?.agencyId;
  const agencyInfoRef = useRef();
  const saleInfoHeaderRef = useRef();
  const app = useSelector((state) => state.app);
  const { user, permissionList } = useSelector((state) => state.auth);
  const [agencyDetail, setAgencyDetail] = useState(null);
  const [isWide, setIsWide] = useState(window.innerWidth > 992);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(t('Danh sách hợp đồng'));
  const agencyBank = agencyDetail?.bankAccounts?.length ? agencyDetail?.bankAccounts[0] : {};
  const [isShowInvestmentCard, setShowInvestmentCard] = useState(true);
  const [isEnergyCommissionOn, setIsEnergyCommissionOn] = useState(true);
  const [salesEnergyCommission, setSalesEnergyCommission] = useState();
  const [isCoinvestorEnergyCommissionOn, setIsCoinvestorEnergyCommissionOn] = useState(true);
  const [coinvestorEnergyCommission, setCoinvestorEnergyCommission] = useState();
  const [isLandlordCommissionOn, setIsLandlordCommissionOn] = useState(true);
  const [isAddContractDone, setAddContractDone] = useState(false);
  const isAgencyIndividual = useMemo(() => {
    return agencyDetail && agencyDetail?.type === AppConstants.accountType.individual;
  }, [agencyDetail]);
  const isHasSaleRole = useMemo(() => {
    return agencyDetail?.contracts?.some(
      (contract) => contract?.contractRole === 'SALE' && contract?.status === 'COMPLETED'
    ) ?? false;
  }, [agencyDetail]);
  const operatorId = useMemo(() => {
    return app?.appConfig?.operators?.[0]?.operatorId ?? null;
  }, [app]);
  const commissionRateSale = useAppConfig()?.commissionRateSale;
  const commissionRateGroup = useAppConfig()?.commissionRateGroup;
  const commissionRateLandlord = useAppConfig()?.commissionRateLandlord;

  const adminRole =
    user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
  const [parentAgencyDetail, setParentAgencyDetail] = useState();
  useEffect(() => {
    if (agencyDetail?.parentAgencyId) {
      AgencyHelper.API.requestAgencyDetail(agencyDetail?.parentAgencyId).then((data) => {
        setParentAgencyDetail(data);
      });
    }
  }, [agencyDetail]);

  const [filterTransaction, setFilterTransaction] = useState({
    agencyId: agencyId,
    q: '',
    from: '',
    to: '',
    status: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    forRole: '',
  });
  const [transactionTotal, setTransactionTotal] = useState(0);
  const [transactionList, setTransactionList] = useState([]);
  const [coinvestorCommission, setCoinvestorCommission] = useState('');
  const [saleCommission, setSaleCommission] = useState('');
  const [commissionUnit, setCommissionUnit] = useState('');
  const [agencyBankList, setAgencyBankList] = useState([]);

  const areaTree = useSelector((state) => state.app.areaTree);
  const [agencyArea, setAgencyArea] = useState(null);
  const [agencyParentArea, setAgencyParentArea] = useState(null);
  useEffect(() => {
    if (areaTree && !_.isEmpty(areaTree) && agencyDetail) {
      const agencyAreaId = agencyDetail?.areaId;
      const agencyArea = ChargeHelper.Utils.getAreaById([areaTree], agencyAreaId);
      setAgencyArea(agencyArea);
      setAgencyParentArea(ChargeHelper.Utils.getAreaById([areaTree], agencyArea?.parentId));
    }
  }, [areaTree, agencyDetail]);

  useEffect(() => {
    const coinvestorCommission =
      agencyDetail?.commissions?.length > 0
        ? agencyDetail.commissions.find((item) => item?.role === 'COINVESTOR')
        : [];
    setCoinvestorCommission(coinvestorCommission);
    const saleCommission =
      agencyDetail?.commissions?.length > 0
        ? agencyDetail.commissions.find((item) => item?.role === 'SALE' && !item?.stationId)
        : [];
    setSaleCommission(saleCommission);
    const salesEnergyCommission =
      agencyDetail?.commissions?.length > 0
        ? agencyDetail.commissions.find((item) => item?.role === 'SALE' && item?.stationId && item?.isInvestorEnergyCommission)
        : [];
    setSalesEnergyCommission(salesEnergyCommission);
    const coinvestorEnergyCommission =
      agencyDetail?.commissions?.length > 0
        ? agencyDetail.commissions.find((item) => item?.role === 'SALE' && item?.stationId && !item?.isInvestorEnergyCommission)
        : [];
    setCoinvestorEnergyCommission(coinvestorEnergyCommission);
  }, [agencyDetail]);

  useEffect(() => {
    const handleGetTransactionList = async () => {
      const res = await agencyCommissionApi.getAgencyCommissionTransactions(filterTransaction);
      const { total, transactions } = res;
      setTransactionList(transactions);
      setTransactionTotal(total);
    };
    if (adminRole) handleGetTransactionList();
  }, [filterTransaction, adminRole]);

  useEffect(() => {
    getAgencyDetail(agencyId);
  }, [agencyId]);

  const getAgencyDetail = (id) => {
    DealerHelper.callApiGetAgencyDetail(id).then((data) => {
      if (Object.keys(data)?.length > 0) {
        setAgencyDetail({ ...agencyDetail, ...data });
      } else {
        router.navigate(-1);
      }
    });
  };
  useEffect(() => {
    handleSetCommissionUnit(salesEnergyCommission?.energyCommissionMode);
  }, [salesEnergyCommission]);

  useEffect(() => {
    if (
      saleCommission?.length ||
      (typeof saleCommission === 'object' && Object.values(saleCommission)?.length)
    ) {
      const hasValidLandlordCommission = Array.isArray(saleCommission?.landlordCommission) &&
        saleCommission.landlordCommission.some(item => item != null);

      setIsLandlordCommissionOn(hasValidLandlordCommission);
    }
  }, [saleCommission]);

  const handleSetCommissionUnit = (value) => {
    if (DealerHelper.checkPercentCommissionMode(value)) {
      setCommissionUnit('%');
    } else {
      setCommissionUnit('VNĐ/kWh');
    }
  };

  useEffect(() => {
    const handleResize = () => setIsWide(window.innerWidth > 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (adminRole || isCoinvestorInfo) {
      handleGetAgencyBankList();
    }
  }, [agencyId, adminRole, isCoinvestorInfo]);

  const handleGetAgencyBankList = async () => {
    const res = await agencyBankHelper.callApiGetAgencyBankList({ agencyId: agencyId });
    setAgencyBankList(res);
  };

  useEffect(() => {
    if (
      salesEnergyCommission?.length ||
      (typeof salesEnergyCommission === 'object' && Object.values(salesEnergyCommission)?.length)
    ) {
      if (salesEnergyCommission?.energyCommissionValue || salesEnergyCommission?.energyCommissionDuration) {
        setIsEnergyCommissionOn(true);
      } else setIsEnergyCommissionOn(false);

    } else setIsEnergyCommissionOn(false);
  }, [salesEnergyCommission]);

  useEffect(() => {
    if (
      coinvestorEnergyCommission?.length ||
      (typeof coinvestorEnergyCommission === 'object' && Object.values(coinvestorEnergyCommission)?.length)
    ) {
      if (coinvestorEnergyCommission?.energyCommissionValue || coinvestorEnergyCommission?.energyCommissionDuration) {
        setIsCoinvestorEnergyCommissionOn(true);
      } else setIsCoinvestorEnergyCommissionOn(false);

    } else setIsCoinvestorEnergyCommissionOn(false);
  }, [coinvestorEnergyCommission]);

  const [selectedChargeStation, setSelectedChargeStation] = useState(null);
  useEffect(() => {
    if (salesEnergyCommission?.stationId) {
      ChargeHelper.API.getChargeStationDetail(salesEnergyCommission?.stationId).then((station) => {
        setSelectedChargeStation({
          id: station?.stationId,
          stationCode: station?.stationCode,
          name: station?.name,
          item: station,
          address: ChargeHelper.Utils.getChargeStationFullAddress(station),
        });
      });
    }
  }, [salesEnergyCommission])

  const [coinvestorSelectedChargeStation, setCoinvestorSelectedChargeStation] = useState(null);
  useEffect(() => {
    if (coinvestorEnergyCommission?.stationId) {
      ChargeHelper.API.getChargeStationDetail(coinvestorEnergyCommission?.stationId).then((station) => {
        setCoinvestorSelectedChargeStation({
          id: station?.stationId,
          stationCode: station?.stationCode,
          name: station?.name,
          item: station,
          address: ChargeHelper.Utils.getChargeStationFullAddress(station),
        });
      });
    }
  }, [coinvestorEnergyCommission])

  // tong quan nha dau tu NQ
  const [coinvestorSummary, setCoinvestorSummary] = useState({});
  useEffect(() => {
    if (Utils.isValid(agencyId)) {
      AgencyHelper.API.requestGetInvestorSummary(agencyId).then((response) => {
        setCoinvestorSummary(response);
      });
    }
  }, [agencyId]);

  const [premiseList, setPremiseList] = useState([]);
  useEffect(() => {
    const params = {
      page: 0,
      limit: 5,
      agencyId: agencyId || '',
    };
    AgencyHelper.API.requestGetPremiseList(params)
      .then((response) => {
        setPremiseList(response?.premises);
      })
  }, [agencyDetail]);

  const hash = router?.location?.hash;

  const tabs = useMemo(() => {
    if (adminRole) {
      return [
        t('Danh sách hợp đồng'),
        'NĐT và chủ mặt bằng',
        t('Lịch sử đầu tư & mua hàng'),
        t('chargeStationList'),
        'Lịch sử bán hàng',
        t('Lịch sử giao dịch'),
        'Hóa đơn tiền điện',
        'Tài khoản ngân hàng',
      ].reverse();
    } else if (isCoinvestorInfo) {
      return [t('Danh sách hợp đồng'), 'Tài khoản ngân hàng'].reverse();
    } else {
      return [
        t('Danh sách hợp đồng'),
        t('Lịch sử đầu tư & mua hàng'),
        t('chargeStationList'),
        'Lịch sử bán hàng',
        'Tài khoản ngân hàng',
      ].reverse();
    }
  }, [t, adminRole, isCoinvestorInfo]);

  useEffect(() => {
    if (hash === '#contract-list') setSelectedTab(t('Danh sách hợp đồng'));
    if (hash === '#remaining-agencies') setSelectedTab('NĐT và chủ mặt bằng');
    if (hash === '#package-transaction') setSelectedTab(t('Lịch sử đầu tư & mua hàng'));
    if (hash === '#station-list') setSelectedTab(t('chargeStationList'));
    if (hash === '#order-history') setSelectedTab('Lịch sử bán hàng');
    if (hash === '#transaction-history') setSelectedTab('Lịch sử giao dịch');
    if (hash === '#electricity-bill') setSelectedTab('Hóa đơn tiền điện');
    if (hash === '#bank-accounts') setSelectedTab('Tài khoản ngân hàng');
  }, [hash]);

  const contractListView = useMemo(() => {
    return <AgencyContractListView agencyId={agencyId} isAddContractDone={isAddContractDone} onRefresh={() => getAgencyDetail(agencyId)} />;
  }, [agencyDetail, isAddContractDone]);

  const saleOrderListView = useMemo(() => {
    return <AgencySaleOrderListView agencyId={agencyId} />;
  }, [agencyId]);

  // NĐT va chu mat bang
  const [filterRemainingAgencies, setFilterRemainingAgencies] = useState({
    parentAgencyId: agencyId,
    role: 'INVESTOR, GROUP, LANDLORD, COINVESTOR',
    q: '',
    status: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    type: '',
  });
  const [remainingAgenciesTotal, setRemainingAgenciesTotal] = useState(0);
  const [remainingAgenciesList, setRemainingAgenciesList] = useState([]);
  useEffect(() => {
    handleGetRemainingAgenciesList();
  }, [filterRemainingAgencies, agencyId]);
  const handleGetRemainingAgenciesList = async () => {
    try {
      const { total, agencies } = await agencyApi.getAgencyList(filterRemainingAgencies);
      setRemainingAgenciesList(agencies);
      setRemainingAgenciesTotal(total);
    } catch (error) {
      console.error('Error fetching remaining agencies list:', error);
    }
  };
  const remainingAgenciesView = useMemo(() => {
    return (
      <RemainingAgenciesView
        agencyId={agencyId}
        remainingAgenciesList={remainingAgenciesList}
        remainingAgenciesTotal={remainingAgenciesTotal}
        filter={filterRemainingAgencies}
        onFilterChanged={(filter) => {
          setFilterRemainingAgencies({
            ...filterRemainingAgencies,
            ...filter,
          });
        }}
        handleGetRemainingAgenciesList={handleGetRemainingAgenciesList}
      />
    );
  }, [agencyDetail, remainingAgenciesList, remainingAgenciesTotal]);

  // lay lich su giao dich mua goi
  const [filterPurchaseTransaction, setFilterPurchaseTransaction] = useState({
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    contractStatus: '',
    selectedValue: dateFilter.baMuoiNgayGanNhat,
    from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
  });
  const [purchaseTransactionTotal, setPurchaseTransactionTotal] = useState(0);
  const [purchaseTransactionList, setPurchaseTransactionList] = useState([]);
  useEffect(() => {
    const getPurchaseTransactionList = async (agencyId, filterPurchaseTransaction) => {
      const params = {
        buyerId: agencyId,
        ...filterPurchaseTransaction,
      };
      setLoading(true);
      const res = await axiosClient.get('/sale', { params });
      setLoading(false);
      const { result, sales, total } = res;
      if (result === 'success') {
        setPurchaseTransactionList(sales);
        setPurchaseTransactionTotal(total);
      }
    };
    getPurchaseTransactionList(agencyId, filterPurchaseTransaction);
  }, [agencyId, filterPurchaseTransaction]);
  const purchaseTransactionView = useMemo(() => {
    return (
      <PackageTransactionView
        agencyDetail={agencyDetail}
        agencyId={agencyId}
        adminRole={adminRole}
        packageTransactionList={purchaseTransactionList}
        packageTransactionTotal={purchaseTransactionTotal}
        filter={filterPurchaseTransaction}
        onFilterChanged={(filter) => {
          setFilterPurchaseTransaction({
            ...filterPurchaseTransaction,
            ...filter,
          });
        }}
      />
    );
  }, [agencyDetail, purchaseTransactionList, purchaseTransactionTotal]);

  const listTransactionHistoryView = useMemo(() => {
    return (
      <TransactionHistoryView
        agencyRole='INVESTOR'
        agencyDetail={agencyDetail}
        transactionList={transactionList}
        transactionTotal={transactionTotal}
        filter={filterTransaction}
        onFilterChanged={(filter) => {
          setFilterTransaction({
            ...filterTransaction,
            ...filter,
          });
        }}
      />
    );
  }, [agencyDetail, transactionList, transactionTotal]);

  const energyBillView = useMemo(() => {
    return (
      <EnergyBillListView
        showFullUI={false}
        agencyId={agencyId}
      />
    );
  }, [agencyId]);

  const bankAccountsView = useMemo(() => {
    return (
      <BankAccountsView
        agencyId={agencyId}
        agencyDetail={agencyDetail}
        banksList={agencyBankList}
        getAgencyBankList={handleGetAgencyBankList}
      />
    );
  }, [agencyId, agencyDetail, agencyBankList]);

  const handleSelectedTab = (newTab) => {
    if (selectedTab === newTab) return;
    if (newTab === 'Danh sách hợp đồng') {
      router.navigate('#contract-list');
    }
    if (newTab === 'NĐT và chủ mặt bằng') {
      router.navigate('#remaining-agencies');
    }
    if (newTab === 'Lịch sử đầu tư & mua hàng') {
      router.navigate('#package-transaction');
    }
    if (newTab === t('chargeStationList')) {
      router.navigate('#station-list');
    }
    if (newTab === 'Lịch sử bán hàng') {
      router.navigate('#order-history');
    }
    if (newTab === 'Lịch sử giao dịch') {
      router.navigate('#transaction-history');
    }
    if (newTab === 'Hóa đơn tiền điện') {
      router.navigate('#electricity-bill');
    }
    if (newTab === 'Tài khoản ngân hàng') {
      router.navigate('#bank-accounts');
    }
    setSelectedTab(newTab);
  };

  const handleCreateSaleCommission = async () => {
    await DealerHelper.callApiCreateAgencyCommission(
      Utils.transformEmptyStrings({
        operatorId: operatorId,
        agencyId: agencyDetail?.agencyId,
        role: 'SALE',
        energyCommissionMode: AppConstants.energyCommissionMode.fixedPerKwh,
        energyCommissionValue: 0,
        energyCommissionDuration: null,
        serviceCommission: 0,
        saleCommission: [
          {
            revenue: 0,
            discount: Number(commissionRateSale),
          },
        ],
        packageCommission: [
          {
            revenue: 0,
            discount: Number(commissionRateGroup),
          },
        ],
        landlordCommission: JSON.parse(commissionRateLandlord),
      })
    );
    getAgencyDetail(agencyId);
  };

  const AgencyInfo = () => {
    return (
      <div
        className={`row m-0 position-relative p-3 bg-white rounded-lg`}
        style={{
          border: `1px solid ${AppColors.gray[300]}`,
          boxShadow: '0px 7px 8px -3px #0000000D',
        }}
      >
        <div className="d-flex px-0 align-items-start w-100">
          <div className="d-flex align-items-center w-95">
            <img
              className="rounded-circle"
              src={
                (() => {
                  const ownerUser = agencyDetail?.users?.find(
                    user => user?.email === agencyDetail?.email
                  );
                  return ownerUser?.avatar
                    ? Utils.getFullUrl(ownerUser.avatar)
                    : AppResource.icons.avatar.default;
                })()
              }
              style={{
                width: 44,
              }}
            />
            <div className="d-flex flex-column ml-3 w-100">
              <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                <div
                  // className="font-weight-bolder text-ellipsis-2-lines"
                  style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                >
                  {agencyDetail?.name}
                </div>

                <span className="min-w-100px pt-1">
                  <KTLabel
                    text={t(`agencyStatus_${agencyDetail?.status}`)}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(
                      agencyDetail?.status
                    )}`}
                  />
                </span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <div
                  style={{
                    color: AppColors.gray[700],
                    fontSize: Utils.returnFontSize(14),
                    fontWeight: 400,
                  }}
                >
                  {t('Số dư ví:')}
                </div>
                <span
                  style={{
                    color: AppColors.gray[800],
                    fontSize: Utils.returnFontSize(13),
                    fontWeight: 600,
                  }}
                >
                  {Utils.formatNumber(agencyDetail?.balance)} VNĐ
                </span>
              </div>
            </div>
          </div>

          <div className="d-flex gap-3 justify-content-end ml-auto">
            <VITableRowDropDown
              toggleElement={
                <a
                  href="#"
                  className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                  style={{ backgroundColor: AppColors.gray[200] }}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <i
                    className="fa-solid fa-ellipsis"
                    style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                  />
                </a>
              }
              menuItem={[
                {
                  iconElement: <i className={`fa-regular fa-bolt`}></i>,
                  text: t('Kích hoạt tài khoản'),
                  click: () => {
                    DealerHelper.handleAcceptAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show: agencyDetail?.status === 'REGISTERED'
                    && (adminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorUpdate?.code),
                },
                {
                  iconElement: <i className="fa-regular fa-pen-to-square"></i>,
                  text: t('edit'),
                  click: () => {
                    BreadcrumbHelper.setBreadcrumPath(
                      `Chỉnh sửa NĐT nhượng quyền`,
                      `${router?.pathname}/edit`
                    );
                    router.navigate('edit');
                  },
                  show: (!agencyDetail?.numberOfSignedContracts
                    && DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    )
                    || adminRole || isCoinvestorInfo)
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorUpdate?.code),
                },
                {
                  iconElement: <i className="fa-regular fa-plus-circle"></i>,
                  text: t('addOrder'),
                  click: () => {
                    router.navigate(`add-order?coinvestor=${agencyDetail?.agencyId}`);
                  },
                  show:
                    agencyDetail?.status === 'NORMAL' &&
                    (adminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && !isCoinvestorInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorUpdate?.code),
                },
                {
                  iconElement: <i className="far fa-square"></i>,
                  text: t('Ngừng hoạt động'),
                  click: () => {
                    DealerHelper.handleStopAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show:
                    agencyDetail?.status === 'NORMAL'
                    && (adminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && !isCoinvestorInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorUpdate?.code),
                },
                {
                  iconElement: <i className="far fa-play"></i>,
                  text: t('Khôi phục hoạt động'),
                  click: () => {
                    DealerHelper.handleActiveAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show:
                    agencyDetail?.status === 'SUSPENDED'
                    && (adminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && !isCoinvestorInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorUpdate?.code),
                },
                {
                  iconElement: <i className="fa-regular fa-file-contract"></i>,
                  text: 'Tạo hợp đồng CTV',
                  click: () => {
                    AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(
                      agencyDetail,
                      () => {
                        setAddContractDone(true)
                      },
                      undefined,
                      async () => {
                        const hasSaleCommission =
                          agencyDetail && agencyDetail.commissions
                            ? await agencyDetail.commissions.some(
                              (commission) => commission?.role === 'SALE'
                            )
                            : false;

                        if (!hasSaleCommission) {
                          await handleCreateSaleCommission();
                        }
                      }
                    );
                  },
                  show:
                    agencyDetail?.status !== 'REGISTERED'
                    && adminRole
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorUpdate?.code),
                },
                {
                  iconElement: (
                    <i
                      className={`fa-regular fa-lock`}
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('Đặt lại mật khẩu'),
                  click: () => {
                    DealerHelper.showDialogChangePassword(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show: adminRole && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorUpdate?.code),
                },
                {
                  iconElement: <i className={`fa-regular fa-trash-can`}></i>,
                  text: t('Xóa nhà đầu tư'),
                  click: () => {
                    DealerHelper.handleDeleteAgency(agencyDetail, () => {
                      router.navigate(-1);
                    });
                  },
                  show: !agencyDetail?.numberOfSignedContracts
                    && (adminRole || DealerHelper.checkHasEditPermission(
                      agencyDetail,
                      parentAgencyDetail,
                      user?.agency
                    ))
                    && !isCoinvestorInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.coinvestorDelete),
                },
              ]}
              singleBtnBgColor={AppColors.gray[200]}
            />
          </div>
        </div>

        <div
          className="my-4"
          style={{
            borderTop: `1px dashed ${AppColors.gray[300]}`,
          }}
        />

        {/* thong tin Dai ly */}
        <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
          <div className=" d-flex flex-lg-row flex-column flex-wrap">
            <>
              <div className="col-xl-6 p-0 pr-xl-3 pl-0 d-flex flex-column gap-3">
                {AgencyUIHelper.buildAccountInfoCard(agencyDetail, parentAgencyDetail, isAgencyIndividual, "INVESTOR")}

                {/* 'Thông tin định danh eKYC' */}
                {isAgencyIndividual && AgencyUIHelper.buildEKYCInfoCard(agencyDetail, () => getAgencyDetail(agencyId))}

                {isAgencyIndividual && AgencyUIHelper.buildHsmAgreementCard(agencyDetail)}
              </div>

              <div className="col-xl-6 p-0 pl-0 d-flex flex-column gap-3 mt-4 mt-lg-0">
                {AgencyUIHelper.buildOtherInfoCard(agencyDetail, agencyParentArea, agencyArea, agencyBank, isAgencyIndividual, adminRole, isCoinvestorInfo)}

                {AgencyUIHelper.buildDocumentInfoCard(agencyDetail, isAgencyIndividual)}

                {!isAgencyIndividual && AgencyUIHelper.buildHsmAgreementCard(agencyDetail)}
              </div>
            </>
          </div>
        </div>
      </div>
    );
  };

  const coinvestorCardsList = [
    {
      title: 'Thông tin đầu tư',
      checked: isShowInvestmentCard,
      click: () => setShowInvestmentCard(true),
      disabled: false,
    },
    {
      title: 'Thông tin bán hàng',
      checked: !isShowInvestmentCard,
      click: () => setShowInvestmentCard(false),
      disabled: !isHasSaleRole,
    },
  ];

  const handleGetLandlordCommissionType = (row) => {
    if (!row) return 'Không xác định';

    const hasFixedCommission = row?.sales[0]?.amount > 0;
    if (hasFixedCommission && row?.saleEnergyCommissionValue === 0 && row?.saleEnergyCommissionDuration === 0) {
      return 'Hoa hồng cố định';
    }
    if (!hasFixedCommission && row?.saleEnergyCommissionValue > 0 && row?.saleEnergyCommissionDuration > 0) {
      return 'Hoa hồng theo doanh thu điện';
    }
    if (hasFixedCommission && row?.saleEnergyCommissionValue > 0 && row?.saleEnergyCommissionDuration > 0) {
      return 'Hoa hồng kết hợp';
    }
    return 'Hoa hồng cố định';
  };

  return (
    <div>
      <div className="w-100">
        {!isCoinvestorInfo && BreadcrumbHelper.buildBreadcrumb([
          {
            title: `Danh sách NĐT liên kết`,
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết NĐT liên kết' },
        ])}
      </div>

      <div className={`m-4 ${!isCoinvestorInfo ? 'mt-16' : ''}`}>
        {/* thong tin Nha dau tu */}
        <CustomCard
          showHeader={false}
          additionalClassName="rounded-lg overflow-hidden"
          bgTransparent={true}
          showBorder={false}
          body={
            <div className="d-xl-flex d-lg-flex">
              {/* thong tin Nha dau tu */}
              <div className={`${(adminRole || isCoinvestorInfo) ? 'col-9' : 'col-12'} p-0`}
                ref={agencyInfoRef}
              >
                <AgencyInfo />
              </div>

              {(adminRole || isCoinvestorInfo) && (
                <div className="d-flex flex-column col-xl-3 col-lg-3 col-md-12 m-0 pl-4 pr-0 mb-sm-5 mb-lg-0 mt-5 mt-lg-0">
                  <div className="d-flex gap-3"
                    ref={saleInfoHeaderRef}
                  >
                    {coinvestorCardsList.map((card, index) => (
                      <div key={index}>
                        <KTRadio
                          name={card.title}
                          checked={card.checked}
                          label={card.title}
                          type={KTRadioType.outline}
                          additionalClassName="radio-success gap-2"
                          onChange={() => card.click()}
                          disabled={card.disabled}
                        />
                      </div>
                    ))}
                  </div>

                  <div className="mt-5">
                    {/* {isShowInvestmentCard && (
                      <BuildInfoCardView
                        bgIconColor="#00C7BE"
                        icon={<i className="fas fa-bolt fa-2x text-white" />}
                        name="Hoa hồng tiền điện"
                        contents={[
                          {
                            value: coinvestorCommission?.energyCommissionMode
                              ? t(`energyCommissionMode_${coinvestorCommission?.energyCommissionMode}`)
                              : '',
                            description: 'Mô hình chia sẻ doanh thu',
                          },
                          {
                            value:
                              coinvestorCommission?.energyCommissionValue != null
                                ? Utils.formatNumber(
                                  DealerHelper.reformatCommissionMode(
                                    coinvestorCommission?.energyCommissionMode,
                                    coinvestorCommission?.energyCommissionValue
                                  )
                                ) + ` ${commissionUnit}`
                                : '',
                            description: 'Mức hoa hồng',
                          },
                        ]}
                      />
                    )} */}
                    {isShowInvestmentCard && (
                      <BuildInfoCardView
                        type="text"
                        bgIconColor="#00C7BE"
                        icon={<i className="fas fa-bolt fa-2x text-white" />}
                        name="Thông tin đầu tư LK"
                        contents={[
                          {
                            description: 'Tổng số trạm sạc',
                            value: Utils.formatNumber(coinvestorSummary?.totalStations ?? 0),
                            additionalTooltip: (
                              <KTTooltip
                                text={`<div><span>Trạm sạc ô tô: ${Utils.formatNumber(
                                  coinvestorSummary?.carStations ?? 0
                                )}</span><br /><span>Trạm sạc xe máy: ${Utils.formatNumber(
                                  coinvestorSummary?.bikeStations ?? 0
                                )}</span></div>`}
                                textHeader="Số trạm sạc"
                                isHtmlContent
                              >
                                <i className="fa-regular fa-info-circle" style={{ color: AppColors.primary }} />
                              </KTTooltip>
                            )
                          },
                          {
                            description: 'Tổng chi phí đầu tư',
                            value: `${Utils.formatNumber(coinvestorSummary?.totalInvestment ?? 0)} VNĐ`,
                          },
                          {
                            description: '',
                            value: '<div style="border-top: 1px dashed #DBDFF1;"></div>',
                          },
                          {
                            description: 'Tổng doanh thu NĐT đã nhận',
                            value: `${Utils.formatNumber(coinvestorSummary?.totalRevenue ?? 0)} VNĐ`,
                          },
                          {
                            description: '',
                            value: '<div style="border-top: 1px dashed #DBDFF1;"></div>',
                          },
                          {
                            description: '',
                            value: `
        <div>
          <div style="font-weight: 600; font-size: 14px; color: #494968;">
            <div style="font-weight: 700; color: #494968; font-size: 14px">${t(coinvestorCommission?.energyCommissionMode)}</div>
            <div style="font-weight: 500; color: #72728B; font-size: 13px">Mô hình chia sẻ doanh thu</div>
          </div>
          <div style="border: 1px solid #DBDFF1; margin-top: 10px; border-radius: 5px; padding: 10px">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div style="font-weight: 500; color: #6B7280;">Loại phương tiện</div>
              <div style="font-weight: 600;">Ô tô</div>
            </div>
            <div style="border-top: 1px dashed #DBDFF1;"></div>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div style="font-weight: 500; color: #6B7280;">Số tiền cố định</div>
              <div style="font-weight: 600;">${Utils.formatNumber(coinvestorCommission?.energyCommissionForCar ?? 0)} VNĐ/kWh</div>
            </div>
          </div>
          <div style="border: 1px solid #DBDFF1; margin-top: 10px; border-radius: 5px; padding: 10px">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div style="font-weight: 500; color: #6B7280;">Loại phương tiện</div>
              <div style="font-weight: 600;">Xe máy</div>
            </div>
            <div style="border-top: 1px dashed #DBDFF1;"></div>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div style="font-weight: 500; color: #6B7280;">Số tiền cố định</div>
              <div style="font-weight: 600;">${Utils.formatNumber(coinvestorCommission?.energyCommissionForBike ?? 0)} VNĐ/kWh</div>
            </div>
          </div>
        </div>
        `.trim(),
                          },
                        ]}
                        additionalClassName="mb-4"
                        isHidden={true}
                      />
                    )}

                    {!isShowInvestmentCard && (
                      <KTScrollCard
                        containerHeight={`${agencyInfoRef.current?.offsetHeight - saleInfoHeaderRef.current?.offsetHeight - 17}px`}
                      >
                        <BuildInfoCardView
                          type="table"
                          commissionType="package"
                          bgIconColor="#8676FF"
                          icon={<i className="fas fa-chart-user fa-2x text-white" />}
                          name="Bán gói đầu tư HTKD"
                          defaultText="Mức hoa hồng mặc định"
                          defaultValue={
                            saleCommission?.packageCommission?.length &&
                            `${Math.round(saleCommission?.packageCommission[0]?.discount * 100)}%`
                          }
                          textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                          contents={
                            saleCommission?.packageCommission?.length &&
                            DealerHelper.handleReformatCommission(saleCommission?.packageCommission)?.slice(1)
                          }
                          additionalClassName="mb-4"
                        />

                        <BuildInfoCardView
                          type="table"
                          commissionType="sale"
                          bgIconColor="#4CADE3"
                          icon={<i className="fas fa-chart-line-up fa-2x text-white" />}
                          name="Bán nhượng quyền"
                          defaultText="Mức hoa hồng mặc định"
                          defaultValue={
                            saleCommission?.saleCommission?.length &&
                            `${Math.round(saleCommission?.saleCommission[0]?.discount * 100)}%`
                          }
                          textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                          contents={
                            saleCommission?.saleCommission?.length &&
                            DealerHelper.handleReformatCommission(saleCommission?.saleCommission)?.slice(1)
                          }
                          additionalClassName="mb-4"
                        />

                        <BuildInfoCardView
                          type="table"
                          commissionType="sale"
                          bgIconColor="#DD4B92"
                          icon={<i className="fas fa-chart-network fa-2x text-white" />}
                          name="Bán liên kết"
                          defaultText="Mức hoa hồng mặc định"
                          defaultValue={
                            saleCommission?.coinvestorCommission?.length &&
                            `${Math.round(saleCommission?.coinvestorCommission[0]?.discount * 100)}%`
                          }
                          textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                          contents={
                            saleCommission?.coinvestorCommission?.length &&
                            DealerHelper.handleReformatCommission(saleCommission?.coinvestorCommission)?.slice(1)
                          }
                          additionalClassName="mb-4"
                        />

                        <BuildInfoCardView
                          type="table"
                          commissionType="sale"
                          bgIconColor="#42D1B5"
                          icon={<i className="fas fa-charging-station fa-2x text-white" />}
                          name="Bán trụ sạc"
                          defaultText="Mức hoa hồng mặc định"
                          defaultValue={
                            saleCommission?.chargePointCommission?.length &&
                            `${Math.round(saleCommission?.chargePointCommission[0]?.discount * 100)}%`
                          }
                          textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                          contents={
                            saleCommission?.chargePointCommission?.length &&
                            DealerHelper.handleReformatCommission(saleCommission?.chargePointCommission)?.slice(1)
                          }
                          additionalClassName="mb-4"
                        />

                        {/* {isLandlordCommissionOn && Array.isArray(saleCommission?.landlordCommission) && (
                          <BuildInfoCardView
                            type="table"
                            commissionType="landlord"
                            bgIconColor="#F8A51E"
                            icon={<i className="fas fa-house-chimney-user fa-2x text-white" />}
                            name="Giới thiệu mặt bằng"
                            defaultText="Mức hoa hồng áp dụng cho mỗi loại mặt bằng"
                            textHeader={['Loại mặt bằng', 'Mức hoa hồng']}
                            contents={saleCommission?.landlordCommission}
                            additionalClassName="mb-4"
                          />
                        )} */}

                        {isLandlordCommissionOn && (
                          <BuildInfoCardView
                            type="table"
                            bgIconColor="#F8A51E"
                            icon={<i className="fas fa-house-chimney-user fa-2x text-white" />}
                            name="Giới thiệu mặt bằng"
                            defaultText="Mức hoa hồng áp dụng cho mỗi loại mặt bằng"
                            textHeader={['Mã mặt bằng', 'Cách tính']}
                            contents={premiseList?.map(premise => ({
                              name: `<div 
                                    style="font-weight: 600; color: #30BD6F; cursor: pointer;" 
                                    onclick="window.open('${AppRoute.premisesList}/${premise?.premiseId || 'Không xác định'}', '_blank')"
                                  >${premise?.name}</div>`,
                              value: `<div 
                                    style="font-weight: 500; color: #494968; cursor: pointer;" 
                                  >${handleGetLandlordCommissionType(premise)}</div>`
                            }))}
                            additionalButton={(
                              <div>
                                {/* {UIHelper.buildNegativeButton('Xem danh sách mặt bằng', () => {
                                Utils.openInNewTab(`${AppRoute.premisesList}`)
                              })} */}
                              </div>
                            )}
                            additionalClassName="mb-4"
                          />
                        )}

                        {isEnergyCommissionOn && (
                          <BuildInfoCardView
                            bgIconColor="#00C7BE"
                            icon={<i className="fas fa-bolt fa-2x text-white" />}
                            name="Hoa hồng tiền điện NQ"
                            contents={[
                              {
                                value: salesEnergyCommission?.energyCommissionMode
                                  ? t(`energyCommissionMode_${salesEnergyCommission?.energyCommissionMode}`)
                                  : '',
                                description: 'Mô hình chia sẻ doanh thu',
                              },
                              {
                                value:
                                  salesEnergyCommission?.energyCommissionValue != null
                                    ? Utils.formatNumber(
                                      DealerHelper.reformatCommissionMode(
                                        salesEnergyCommission?.energyCommissionMode,
                                        salesEnergyCommission?.energyCommissionValue
                                      )
                                    ) + ` ${commissionUnit}`
                                    : '',
                                description: 'Mức hoa hồng mặc định',
                              },
                              {
                                value:
                                  salesEnergyCommission?.energyCommissionDuration == null ||
                                    salesEnergyCommission?.energyCommissionDuration == 0
                                    ? 'Không thời hạn'
                                    : salesEnergyCommission?.energyCommissionDuration + ' tháng',
                                description: 'Thời gian áp dụng',
                              },
                              {
                                value:
                                  selectedChargeStation?.name ?? '',
                                description: 'Trạm sạc áp dụng',
                              },
                            ]}
                            additionalClassName="mb-4"
                          />
                        )}

                        {isCoinvestorEnergyCommissionOn && (
                          <BuildInfoCardView
                            bgIconColor="#4287D1"
                            icon={AppResource.icons.evg.icCoinvestorEnergy}
                            name="Hoa hồng tiền điện liên kết"
                            contents={[
                              {
                                value: coinvestorEnergyCommission?.energyCommissionMode
                                  ? t(`energyCommissionMode_${coinvestorEnergyCommission?.energyCommissionMode}`)
                                  : '',
                                description: 'Mô hình chia sẻ doanh thu',
                              },
                              {
                                value:
                                  coinvestorEnergyCommission?.energyCommissionValue != null
                                    ? Utils.formatNumber(
                                      DealerHelper.reformatCommissionMode(
                                        coinvestorEnergyCommission?.energyCommissionMode,
                                        coinvestorEnergyCommission?.energyCommissionValue
                                      )
                                    ) + ` ${commissionUnit}`
                                    : '',
                                description: 'Mức hoa hồng mặc định',
                              },
                              {
                                value:
                                  coinvestorEnergyCommission?.energyCommissionDuration == null ||
                                    coinvestorEnergyCommission?.energyCommissionDuration == 0
                                    ? 'Không thời hạn'
                                    : coinvestorEnergyCommission?.energyCommissionDuration + ' tháng',
                                description: 'Thời gian áp dụng',
                              },
                              {
                                value:
                                  coinvestorSelectedChargeStation?.name ?? '',
                                description: 'Trạm sạc áp dụng',
                              },
                            ]}
                          />
                        )}
                      </KTScrollCard>
                    )}
                  </div>
                </div>
              )
              }
            </div >
          }
        />

        {/* table */}
        <div>
          <AppTabs
            tabs={tabs}
            activeTab={selectedTab}
            handleClick={handleSelectedTab}
            className="mt-3 mr-3"
            additionalClassName=""
          />
          <div
            className="bg-white shadow"
            style={{
              borderLeft: `1px solid ${AppColors.gray[300]}`,
              borderRight: `1px solid ${AppColors.gray[300]}`,
              borderBottom: `1px solid ${AppColors.gray[300]}`,
              borderRadius: '0px 10px 10px 10px',
            }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedTab}
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -10, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                {selectedTab == t('Danh sách hợp đồng') && (
                  <div className="py-4">{contractListView}</div>
                )}
                {selectedTab == 'NĐT và chủ mặt bằng' && (
                  <div className="px-5 pb-3 pt-4">{remainingAgenciesView}</div>
                )}
                {selectedTab == t('Lịch sử đầu tư & mua hàng') && (
                  <div className="px-5 pb-3 pt-4">{purchaseTransactionView}</div>
                )}
                {selectedTab == t('chargeStationList') && (
                  <div className="">
                    <ChargeStationCompactListView
                      hasAppTab={true}
                      initialFilter={{
                        agencyId: agencyId,
                      }}
                    />
                  </div>
                )}
                {selectedTab == 'Lịch sử bán hàng' && (
                  <div className="px-1 pt-2">{saleOrderListView}</div>
                )}
                {selectedTab == t('Lịch sử giao dịch') && (
                  <div className="px-5 pb-3 pt-4">{listTransactionHistoryView}</div>
                )}
                {selectedTab == 'Hóa đơn tiền điện' && (
                  <div className="pb-3 pt-4">{energyBillView}</div>
                )}
                {selectedTab == 'Tài khoản ngân hàng' && <div>{bankAccountsView}</div>}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div >
    </div >
  );
}

export default CoinvestorDetailScreen;
